/**
 * @packageDocumentation
 * @module api.functional
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

export * as event_logs from "./event_logs/index";
export * as auth from "./auth/index";
export * as invitations from "./invitations/index";
export * as admin from "./admin/index";
export * as companies from "./companies/index";
export * as users from "./users/index";
export * as orders from "./orders/index";
export * as items from "./items/index";
export * as receivings from "./receivings/index";

/**
 * @controller AppController.getHello
 * @path GET /
 * @accessor api.functional.getHello
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getHello(
  connection: IConnection,
): Promise<getHello.Output> {
  return PlainFetcher.fetch(connection, {
    ...getHello.METADATA,
    template: getHello.METADATA.path,
    path: getHello.path(),
  });
}
export namespace getHello {
  export type Output = string;

  export const METADATA = {
    method: "GET",
    path: "/",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/";
}
